import Vue from 'vue'

Vue.prototype.$scrollToFirstErrorInput = function () {
  if (this.$el.querySelector('[data-vv-name="' + this.$validator.errors.items[0].field + '"]')) {
    this.$el.querySelector('[data-vv-name="' + 
      this.$validator.errors.items[0].field + '"]').scrollIntoView()
  }  
} 

Vue.prototype.$logout = function () {
  return this.$store.dispatch('logout')
}

Vue.prototype.$manualLogout = function () {
  return this.$store.dispatch('manualLogout')
}

Vue.prototype.$refreshAccess = function () {
  return this.$store.dispatch('refreshAccess')
}

Vue.prototype.$snack = function (params) {
  return this.$store.commit('app/snack', params, { root: true })
}

Vue.prototype.$hasPermissionTo = function (permissions) {
  let intersections = this.$store.state.permissions.filter(permission => permissions.includes(permission.name))

  return intersections.length === permissions.length
}

Vue.prototype.$resetData = function () {  
  Object.assign(this.$data, this.$options.data.apply(this))
}

Vue.prototype.$dialog = function (params) {
  return this.$store.commit('app/dialog', params, { root: true })
}
